module.exports = __webpack_public_path__ + "img/lampar.83806f1f.jpg";